// extracted by mini-css-extract-plugin
export default {"container":"nq-z","brandName":"oq-z","productName":"pq-z","productNamePdpEnhancements":"qq-z","breakLongProductName":"rq-z"};